import { mapGetters, mapActions } from 'vuex'
import { LandingPage } from '@/components'

const components = {
  LandingPage
}

const computed = {
  ...mapGetters({
    aggregateModels: 'aggregateModels/list',
    lastModelUpdate: 'aggregateModels/lastModelUpdate',
  }),
  currentDate () {
    return this.$store.getters['aggregateModels/currentDate'](this.config.key)
  },
  landingModels () {
    return this.$store.getters[`landingModels/${this.config.key}List`]
  },
  models () {
    return [...this.aggregateModels.filter(model => model.chamber === this.config.param)].sort((a, b) => new Date(a.date) - new Date(b.date))
  },
  model () {
    return this.models.find(model => model.date === this.currentDate)
  }
}

const methods = {
  ...mapActions({
    putCongressionalList: 'landingModels/putCongressionalList'
  })
}

export default {
  components,
  computed,
  methods,
  data: () => ({
    loading: false
  }),
  beforeMount () {
    this.loading = true

    const params = {
      date: this.currentDate,
      chamber:  this.config.param
    }

    const promises = [
      this.putCongressionalList({
        params,
        key: this.config.key
      })
    ]

    Promise.all(promises).then(() => {
      this.loading = false
    })
  }
}